<template>
    <div class="flex h-auto bg-gray-900 text-white">
      <!-- Sidebar -->
      <aside class="w-64 bg-gray-800 p-6 flex flex-col space-y-6 shadow-lg">
        <div class="flex items-center justify-center space-x-3">
       <img src="@/assets/logo.svg" alt="Syniac Logo" class="h-20">
        </div>
        <Navbar></Navbar>
      </aside>
  
      <!-- Main Content -->
      <div class="flex-1 flex flex-col">
        <!-- Top Navbar -->
        <header class="h-16 bg-gray-800 flex items-center justify-between px-6 shadow-md">
          <h2 class="text-xl font-semibold">Annual Income Report</h2>
        </header>
  
        <!-- Income Report Page -->
        <main class="p-6 flex-1">
          <div class="bg-gray-800 p-6 rounded-xl shadow-md flex flex-col h-full">
            <h3 class="text-lg font-semibold mb-4">Income Overview for {{ currentYear }}</h3>
  
            <!-- Income Table -->
            <div class="overflow-x-auto">
              <table class="w-full text-left border-collapse">
                <thead>
                  <tr class="bg-gray-700">
                    <th class="p-3">Month</th>
                    <th class="p-3">Income</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(income, index) in incomeData" :key="index" class="border-b border-gray-600">
                    <td class="p-3">{{ income.month }}</td>
                    <td class="p-3">${{ income.amount }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
  
            <!-- Total Income -->
            <div class="mt-6">
              <h4 class="text-lg font-semibold">Total Income: ${{ totalIncome }}</h4>
            </div>
          </div>
        </main>
      </div>
    </div>
  </template>
  
  <script>
  import Navbar from '@/components/adminnav.vue';
  import axios from 'axios';
  
  export default {
    name: 'IncomeReportPage',
    data() {
      return {
        currentYear: new Date().getFullYear(),
        incomeData: [], // Array of month/income pairs for the current year
        totalIncome: 0,
      };
    },
    methods: {
      async fetchIncomeData() {
        try {
          // Fetch the annual income report data from the server
          const response = await axios.get('https://api.syniac.com:3000/api/admin/report/annual-income-reports', { withCredentials: true });
  
          // Find the data for the current year
          const currentYearData = response.data.find(item => item.year === this.currentYear);
          
          if (currentYearData) {
            // Filter out 'id' and 'year' and map months to income data
            this.incomeData = Object.keys(currentYearData)
              .filter(month => month !== 'id' && month !== 'year')
              .map(month => ({
                month,
                amount: currentYearData[month] || 0 // Assign 0 if the income is missing
              }));
              
            this.calculateTotalIncome();
          }
        } catch (error) {
          console.error('Error fetching income data:', error);
        }
      },
      
      calculateTotalIncome() {
        // Calculate total income by summing up the amounts for each month
        this.totalIncome = this.incomeData.reduce((acc, data) => {
          return acc + parseFloat(data.amount); // Add the income value for each month
        }, 0);
      }
    },
    
    mounted() {
      // Fetch the income data for the current year when the component is mounted
      this.fetchIncomeData();
    },
    
    components: {
      Navbar,
    }
  };
  </script>
  
